import convertRestFolderIdToEWSFolderId from '../../utils/convertRestFolderIdToEWSFolderId';
import folderStore from 'mini-mail-folder-store/lib/store/Store';
import getFavorites from 'owa-session-store/lib/utils/getFavorites';
import getUserMailboxInfo from 'owa-client-ids/lib/utils/getUserMailboxInfo';
import type OutlookFavoriteKind from 'mini-mail-folder-store/lib/store/schema/OutlookFavoriteKind';
import type OutlookFavoriteServiceDataType from 'mini-mail-folder-store/lib/store/schema/OutlookFavoriteServiceDataType';
import tryAddSingleFavoriteFolderToStore from './tryAddSingleFavoriteFolderToStore';
import { logUsage } from 'owa-analytics';

/**
 * Load outlook favorites from userConfig.Favorites
 */
export default function loadOutlookFavorites() {
    const outlookFavorites = getFavorites(getUserMailboxInfo())?.value;

    outlookFavorites &&
        outlookFavorites.forEach((serviceData: OutlookFavoriteServiceDataType) => {
            const favoriteType = serviceData.Type?.toLocaleLowerCase() as OutlookFavoriteKind;

            try {
                const folderId = convertRestFolderIdToEWSFolderId(
                    serviceData.SingleValueSettings?.[0].Value ?? ''
                );

                if (favoriteType === 'folder') {
                    tryAddSingleFavoriteFolderToStore(folderId, folderStore);
                }
            } catch (error) {
                // continue execution if a favorite could not be loaded
                logUsage('AddFavoriteToStoreInitialFailed', {
                    favoriteType,
                    error: error.stack.toString(),
                });
            }
        });
}
